import React, { useEffect, useState } from "react";

import CategoryItem from "./categoryItem";
import { trendingCategoryData } from "../../data/categories_data";
import Tippy from "@tippyjs/react";
import Recently_added_dropdown from "../dropdown/recently_added_dropdown";
import { useSelector, useDispatch } from "react-redux";
import { updateTrendingCategoryItemData } from "../../redux/counterSlice";
import { useWallet } from "@demox-labs/aleo-wallet-adapter-react";

import {
  get_user_private_tokens,
  loadTokensData,
  get_public_tokens_owned_by,
  get_user_collections,
  loadPrivacyPridesData,
  get_user_privacy_prides
} from 'lib/client/aleo';
import { useAlert } from "react-alert";


async function loadUserWalletContent(
  toFetchPublicKey,
  publicKey,
  requestRecords,
  alert,
  filterVal,
  setFilterVal,
  setTokens,
  loading,
  setLoading,
  setCollections,
) {
  if (loading)
    return
  setLoading(true);
  try {
    let user_collections = [];

    if (publicKey && requestRecords) {
      user_collections = await get_user_collections(publicKey, requestRecords);
    }
    let ownedTokens = await get_public_tokens_owned_by(toFetchPublicKey);
    ownedTokens = ownedTokens.filter((token) => token);
    ownedTokens = await loadTokensData(ownedTokens);
    setTokens(ownedTokens);
    setCollections(user_collections);
  }
  catch (e) {
    const err_str = e?.error?.message || e?.message || e + "";
    alert.error(err_str);
  }
  setLoading(false);
}

const Trending_categories_items = ({ category, setCategory, toFetchPublicKey }) => {
  const [tokens, setTokens] = useState([])
  const [collections, setCollections] = useState([]);
  const dispatch = useDispatch();
  const { trendingCategorySorText } = useSelector((state) => state.counter);
  const { publicKey, requestRecords } = useWallet();
  const [filterVal, setFilterVal] = useState(0);
  const [loading, setLoading] = useState(false);
  const alert = useAlert();

  const [ownedPublicLoading, setOwnedPublicLoading] = useState(false);

  useEffect(() => {
    loadUserWalletContent(
      toFetchPublicKey, publicKey, requestRecords, alert, filterVal, setFilterVal, setTokens, loading, setLoading, setCollections
    );
  }, [filterVal, category, publicKey, requestRecords, toFetchPublicKey]);

  return (
    <>
      {/* <!-- Filter --> */}

      {/* <!-- Grid --> */}
      {loading && (
        <div className="flex justify-center items-center">
          <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-jacarta-500">
          </div>
        </div>
      )
      }
      {!loading && tokens.length === 0 && (
        <div className="flex justify-center items-center">
          <div className="text-center">
            <div className="text-2xl font-semibold mb-2">No {
              filterVal === 0 ? "public" : (
                filterVal === 1 ? "private" : "")
            } token found</div>
            <div className="text-sm text-jacarta-500 dark:text-jacarta-400 normal-case	">
              This address does not own any public token.
            </div>
          </div>
        </div>
      )}
      {!loading && (<CategoryItem noFeature={true} tokens={tokens} collections={collections} />)}
    </>
  );
};

export default Trending_categories_items;
